import React, { useMemo } from 'react';
import { Preloader } from '@common-fe/common-fe';
import { capitalize } from 'lodash';

import { ModalWrapper } from '@/components/wrappers';
import { useStatesQuery } from '@/modules/core';

import AddBeneficiaryForm from './AddBeneficiaryForm';
import useBeneficiaryRelationshipsTypesQuery from './useBeneficiaryRelationshipsTypes.query';
import { Beneficiary, BeneficiaryType } from './useGetBeneficiaries.query';

interface Props {
  onClose: () => void;
  beneficiaries?: Beneficiary[];
  beneficiaryType?: BeneficiaryType;
}

const AddBeneficiaryModal: React.FC<Props> = ({ beneficiaries, beneficiaryType, onClose }) => {
  const { formattedRelationshipsTypes, isLoading } = useBeneficiaryRelationshipsTypesQuery();
  const { states, isLoading: areStatesLoading } = useStatesQuery();
  const typeTitle = useMemo(() => capitalize(beneficiaryType), [beneficiaryType]);
  const editTitle = useMemo(() => beneficiaries?.length
    ? `Edit ${typeTitle} Beneficiaries`
    : `Add a ${typeTitle} Beneficiary`,
    [beneficiaries, typeTitle]);

  return (
    <ModalWrapper
      testId={`AddOrEditBeneficiaryModal_${beneficiaryType}`}
      visible
      title={editTitle}
      onSetVisible={() => onClose()}
    >
      {isLoading || areStatesLoading ? <Preloader testId="AddBeneficiaryModal" /> : (
        <AddBeneficiaryForm
          beneficiaries={beneficiaries}
          beneficiaryType={beneficiaryType}
          onClose={onClose}
          relationshipsTypes={formattedRelationshipsTypes}
          states={states}
        />
      )}
    </ModalWrapper>
  );
};

export default AddBeneficiaryModal;
